import { connect } from 'react-redux';
import { setAndOpenModal } from '../Modal/modal_actions';
import { setFSphotos } from '../Modal/Full_screen_photos_modal/full_screen_actions';

import EventDetailsCutted from './Event_details_cutted';

const mDTP = { setAndOpenModal, setFSphotos };

export default connect(null, mDTP)(EventDetailsCutted);
